import { render, staticRenderFns } from "./formInvigilando.vue?vue&type=template&id=a1e0e6f4&"
import script from "./formInvigilando.vue?vue&type=script&lang=js&"
export * from "./formInvigilando.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports